import { render, staticRenderFns } from "./TemporarySystemNotice.vue?vue&type=template&id=49bccb8d&scoped=true&"
import script from "./TemporarySystemNotice.vue?vue&type=script&lang=js&"
export * from "./TemporarySystemNotice.vue?vue&type=script&lang=js&"
import style0 from "./TemporarySystemNotice.vue?vue&type=style&index=0&id=49bccb8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bccb8d",
  null
  
)

export default component.exports